import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { map, get } from "lodash";
import List from "react-md/lib/Lists/List";
import ListItem from "react-md/lib/Lists/ListItem";
import Subheader from "react-md/lib/Subheaders";
import Avatar from "react-md/lib/Avatars";
import FontIcon from "react-md/lib/FontIcons";

import { getRequestWithFilter, setFilter } from "../../actions/requestActions";

import { formatTime } from "../../utils";
import {
    requestStatusColor,
    requestStatusText,
    requestStatusBackgroundColor
} from "../../enums";
import {DebugElement} from "../../Atollon/debug";
import {TouchAvatar, TouchTable} from "../../AtollonTheme/ReactElements";

const userAvatar = <Avatar icon={<FontIcon>person</FontIcon>} suffix="black" />;

const RequestTable = (inputParameters ) => {

    var {
          data,
            history,
            main,
            forMe,
            getRequestWithFilter,
            requests,
            setFilter,
            filter,
            pageRequests,
            identifier
    } = inputParameters;
  return (
    <div className="requests-table">
        <DebugElement text={"src/components/requests/RequestTable.js"}/>
      {!requests ? (
        <List className="md-paper--1">
          {data && <Subheader primaryText={data} />}
        </List>
      ) : (

          <div>

              <List className="md-paper--1">
              {data && <Subheader primaryText={data} />}


              {map(requests.item, (item, i) => {

                  let projectName = item.project && item.project.name ? (<span><b>{item.project.name}</b>: </span>) : '';

                  return (
                      <ListItem
                          key={i}
                          leftAvatar={userAvatar}
                          primaryText={<div>{projectName}{item.subject}</div>}
                          secondaryText={
                              item.senderName
                                  ? <span>{item.senderName} (<span className={"link"}>{item.sender}</span>)</span>
                                  : <span className={"link"}>{item.sender}</span>
                          }
                          className="list"
                          onClick={() => history.push(`/requests/${item.hash}`)}
                      >
                          <div className="row">
                              <div className="row-text">
                                  <p className="status">
                                      {get(requestStatusText, get(item, "status"))}
                                  </p>
                                  <p className="date">{formatTime(item.modified)}</p>
                              </div>

                              <div style={{position:'absolute', top:0, left:'-1px', height:'100%'}}>
                                  <div className={requestStatusBackgroundColor(item.status)}
                                       style={
                                           // from outer edge
                                           {position:'absolute', top:0, top:'calc( 11px )', left:0, width:'5px', height: '100%', height: 'calc( 100% - 2 * 11px )'}
                                           // {position:'absolute', top:0, top:'calc( -8px )', left:0, width:'5px', height: '100%', height: 'calc( 100% + 2 * 8px )'}
                                       }>
                                  </div>
                              </div>
                              {/*
                              <div className="row-indicator">
                                  <FontIcon
                                      className={requestStatusColor(item.status)}
                                  >
                                      error
                                  </FontIcon>
                              </div>
                              */}

                          </div>
                      </ListItem>
                  );
              })}


              {
                  /*

              <TouchTable
                  headerAsList={["Projekt/Požadavek/Jméno","Datum/Stav"]}
                  elementsAsList={

                      map(requests.item, (item, i) => {

                          let projectAsReactElement = '';
                          if( item.project )
                          {
                              console.log( 'list project', item.project );
                              projectAsReactElement = item.project.name;
                          }

                          return [
                              (
                                  <div>
                                      {projectAsReactElement}
                                      <TouchAvatar
                                          image={""}
                                          text={item.subject}
                                          subtext={<span><span>{item.senderName}</span> (<span className={"link"}>{item.sender}</span>)</span>}
                                          onClick={() => history.push(`/requests/${item.hash}`)}
                                      />
                                  </div>
                              ),
                              (
                                  <div>
                                      <p className="status">
                                          {get(requestStatusText, get(item, "status"))}
                                      </p>
                                      <p className="date">{formatTime(item.modified)}</p>
                                      <FontIcon
                                          className={requestStatusColor( item.status )}
                                      >
                                          error
                                      </FontIcon>
                                      {item.identifier}
                                  </div>
                              )
                          ];
                      })
                  }
              />
                  */
              }

              {((main && requests.limit < requests.count) ||
                (filter && filter.limit < requests.count)) && (
                <ListItem
                  className="pagination"
                  style={{listStyle:'none'}}
                  primaryText="Více"
                  onClick={() => {
                    if (main) {
                      history.push(`/${forMe ? "requests-me" : "requests-other"}`);
                    } else {
                      setFilter(
                        filter.initial,
                        filter.accepted,
                        filter.resolving,
                        filter.resolved,
                        filter.closed,
                        filter.dismissed,
                        filter.textQuery,
                        filter.limit + 10
                      );
                      if (pageRequests) {
                        getRequestWithFilter(null, identifier, identifier);
                      } else {
                        getRequestWithFilter(forMe ? "PENDING" : "NOT_PENDING");
                      }
                    }
                  }}
                />
              )}
              </List>
        </div>
      )}
    </div>
  );
};

export default compose(connect(null, { getRequestWithFilter, setFilter }))(
  RequestTable
);



// WEBPACK FOOTER //
// ./src/components/requests/RequestTable.js